import type { TBookResponseDTO, TConciergeThreadDTO } from './conciergeThread.dto';

import type { TBookSync, TConciergeThread } from './conciergeThread.types';

const toConciergeThread = (dto: TConciergeThreadDTO): TConciergeThread => ({
  channelID: dto.channel_id,
  conciergeID: dto.concierge_id,
});

const toBookSync = (dto: TBookResponseDTO): TBookSync => ({
  synced: dto.synced,
  failedIDs: dto.failed ?? [],
});

export {
  toBookSync,
  toConciergeThread,
};
